import React from "react";
import "./Fan.css";
import userphoto from "../assets/user.png";
import axios from "axios";

import { baseURL } from "../Config/Config";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

export default function Fan() {
  const [posts, setPosts] = React.useState();

  React.useEffect(() => {
    axios.get(`${baseURL}video/video-material-list-home/`).then((response) => {
      setPosts(response.data);

    }).catch((err) => {
      console.log(err)
    })
  }, []);
  if (!posts) return null;
  return (
    <div className="container">
      <div className="fan-title">
        <h1>Eng ko‘p ko‘rilganlar</h1>
      </div>
      <div className="fan-videos">
        {posts.map((post) => {
          return (
            <div className="card-video" key={post.id}>
              <ReactPlayer
                className="video video"
                url={post.video_link}
                controls = {true}
              />
              <div className="fan-video-title">
                <h4> {post.title}</h4>
                <Link to={`/VideoMaterial/${post.id}`}>{post.sub_content}</Link>
              </div>
              <div className="name">
                <div className="muallif-img">
                  <img src={post.author_photo ? post.author_photo : userphoto} />
                </div>
                <span> {post.author}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
